// extracted by mini-css-extract-plugin
export default {"title":"BodySlice_title__dV+g4","body":"BodySlice_body__Ljjua"};